export default __webpack_public_path__ + "10b294aa1d728b6901fa9c1834bcb9fc.svg";